module.exports = __webpack_public_path__ + "img/13.afaea9d8.jpg";